import { Component, OnInit, TrackByFunction } from '@angular/core';
import {
	ButtonComponent,
	SvgIconComponent,
	TrackEventDirective,
	kebabCase,
	NotificationType,
	replaceSpecialCharacters,
	TrackingEvent,
	WithPageMeta,
} from '@woolworthsnz/styleguide';
import { DepartmentDasFacetsResponse, FilterCriteria } from '@woolworthsnz/trader-api';
import { take } from 'rxjs/operators';
import { SearchService } from '../../search.service';
import { RouterLink } from '@angular/router';
import { NgFor, TitleCasePipe } from '@angular/common';

@WithPageMeta({ pageTitle: 'browse', metaTitle: 'browse', metaDescription: 'browse' })
@Component({
	selector: 'wnz-browse-departments',
	templateUrl: './browse-departments.page.html',
	styleUrls: ['./browse-departments.page.scss'],
	standalone: true,
	imports: [NgFor, RouterLink, TrackEventDirective, SvgIconComponent, ButtonComponent, TitleCasePipe],
})
export class BrowseDepartmentsPage implements OnInit {
	departments: DepartmentDasFacetsResponse[] = [];
	notificationType = NotificationType;
	trackingEvent = TrackingEvent;

	constructor(private searchService: SearchService) {}

	trackByDepartments: TrackByFunction<DepartmentDasFacetsResponse> = (_, department) => department.id;
	trackByFacet: TrackByFunction<FilterCriteria> = (_, facet) => facet.value;

	ngOnInit(): void {
		this.searchService
			.fetchBrowseDepartments()
			.pipe(take(1))
			.subscribe((res) => {
				this.departments = res;
			});
	}

	// TODO POD-6041 - Refactor to service and combine with the method in search-store.service and breadcrumb service
	buildDepartmentUrl(department: DepartmentDasFacetsResponse, facet?: FilterCriteria): string {
		if (facet) {
			const dasFilterName = kebabCase(replaceSpecialCharacters(facet.name || ''));
			return `/shop/browse/${department.url}/${dasFilterName}`;
		}
		return `/shop/browse/${department.url}`;
	}

	buildDepartmentTrackingName(department: DepartmentDasFacetsResponse, facet: FilterCriteria): string {
		const dasFilterName = kebabCase(replaceSpecialCharacters(facet.name || ''));
		return `${department.url} - ${dasFilterName}`;
	}
}
